import { exists } from '@/api'

export interface BibliographyRealDetailMarc {
  marcTag: string
  stringLength: number
  data: string
}

export function BibliographyRealDetailMarcFromJSON(
  json: any
): BibliographyRealDetailMarc {
  return {
    marcTag: exists(json, 'marc_tag') ? json.marc_tag : '',
    stringLength: exists(json, 'string_length') ? json.string_length : 0,
    data: exists(json, 'data') ? json.data : ''
  }
}

export const defaultBibliographyRealDetailMarc = (): BibliographyRealDetailMarc => ({
  marcTag: '',
  stringLength: 0,
  data: ''
})
